import React from "react";
import {
  Container,
  Heading,
  BasicText,
  Highlighter,
  Heading3,
  CodeOuter,
  CodeView,
  LongImage
} from "../styles";
import coverImage from "../assets/coverpage4.png";
import styled from "styled-components";

const Item = styled.li`
  margin: 13px 0px 13px 0px;
`;

class TextInput extends React.Component {
  render() {
    return (
      <Container>
        <Heading>TextInput</Heading>
        <ul>
          <Item>
            <BasicText>
              If <Highlighter>multiline</Highlighter> is true, the text aligns
              on top on Android.
            </BasicText>
          </Item>
          <Item>
            <BasicText>
              The default placeholder text color is{" "}
              <Highlighter>#C7C7CD</Highlighter> on Android, the same as the iOS
              default
            </BasicText>
          </Item>
          <Item>
            <BasicText>
              The default <Highlighter>underlineColorAndroid</Highlighter> is
              <Highlighter>transparent</Highlighter>. This is the default
              behavior since React Native 0.56, so it will only make a
              difference if you still use an older version.
            </BasicText>
          </Item>
        </ul>
        <LongImage>
          <img style={{ paddingTop: 15, marginBottom: 20 }} src={coverImage} />
        </LongImage>
        <Heading3>Usage</Heading3>
        <BasicText>
          You just need to import<Highlighter>TextInput</Highlighter>
          from <b>react-native-normalized</b> instead of <b>react-native!</b>
        </BasicText>
        <CodeOuter>
          <CodeView>
            {
              "import React from 'react';\r\nimport { View } from 'react-native';\r\nimport { TextInput } from 'react-native-normalized';\r\n\r\nclass Example extends React.Component {\r\n  render(){ \r\n    return(\r\n      <View style={{ flex:1}}>\r\n       <TextInput  multiline={true} placeholder=\"Name\"/>\r\n     </View>\r\n    )\r\n  }\r\n}"
            }
          </CodeView>
        </CodeOuter>
      </Container>
    );
  }
}

export default TextInput;
